import { defineComponent as A, openBlock as o, createElementBlock as e, mergeProps as Z, unref as l, renderSlot as d, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, h = { key: 1 }, u = { key: 2 }, v = { key: 3 }, M = { key: 4 }, g = { key: 5 }, f = {
  name: "ScalarIconDeviceMobile"
}, y = /* @__PURE__ */ A({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const V = H, { bind: r, weight: a } = i(V);
    return (s, t) => (o(), e("svg", Z({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(r)), [
      d(s.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", p, t[0] || (t[0] = [
        n("path", { d: "M176,12H80A28,28,0,0,0,52,40V216a28,28,0,0,0,28,28h96a28,28,0,0,0,28-28V40A28,28,0,0,0,176,12ZM76,76H180V180H76Zm4-40h96a4,4,0,0,1,4,4V52H76V40A4,4,0,0,1,80,36Zm96,184H80a4,4,0,0,1-4-4V204H180v12A4,4,0,0,1,176,220Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", h, t[1] || (t[1] = [
        n("path", {
          d: "M192,56V200H64V56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", u, t[2] || (t[2] = [
        n("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM80,32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", v, t[3] || (t[3] = [
        n("path", { d: "M176,18H80A22,22,0,0,0,58,40V216a22,22,0,0,0,22,22h96a22,22,0,0,0,22-22V40A22,22,0,0,0,176,18ZM70,62H186V194H70ZM80,30h96a10,10,0,0,1,10,10V50H70V40A10,10,0,0,1,80,30Zm96,196H80a10,10,0,0,1-10-10V206H186v10A10,10,0,0,1,176,226Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        n("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", g, t[5] || (t[5] = [
        n("path", { d: "M176,20H80A20,20,0,0,0,60,40V216a20,20,0,0,0,20,20h96a20,20,0,0,0,20-20V40A20,20,0,0,0,176,20ZM68,60H188V196H68ZM80,28h96a12,12,0,0,1,12,12V52H68V40A12,12,0,0,1,80,28Zm96,200H80a12,12,0,0,1-12-12V204H188v12A12,12,0,0,1,176,228Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
